// GOBLIN GEAR — rebrand runtime (reveal/glitch observers + helpers). Theme toggle stays in storefront.js.
// No-flash theme setter. Order: theme lock (Theme settings > Lock theme) > this visit's choice > server default.
// Masked (dark) is the starting mode on every visit: a visitor's Known/Masked choice is kept in sessionStorage,
// so it lasts while they browse and resets to Masked next time they come back.
// FIX (Sep 20 2026): this used to force 'light' and ignore data-theme-lock, which silently undid
// Masked/Known mode on every page load. It now respects the lock and never overrides the server default.
(function () {
  var LOCK = document.documentElement.getAttribute('data-theme-lock');
  try {
    var r = document.documentElement;
    if (LOCK) {
      r.setAttribute('data-theme', LOCK);
    } else {
      var s = sessionStorage.getItem('gg-theme');
      if (s === 'dark' || s === 'light') r.setAttribute('data-theme', s);
    }
  } catch (e) {}

  var GG = window.GG = window.GG || {};
  GG.getTheme = function () { return document.documentElement.getAttribute('data-theme') || 'dark'; };
  GG.setTheme = function (t) {
    if (LOCK) return;
    document.documentElement.setAttribute('data-theme', t);
    try { sessionStorage.setItem('gg-theme', t); } catch (e) {}
    window.dispatchEvent(new CustomEvent('gg:theme', { detail: t }));
  };
  GG.toggleTheme = function () { GG.setTheme(GG.getTheme() === 'dark' ? 'light' : 'dark'); };
  // storefront.js owns the toggle click; remember whatever it sets for the rest of this visit only.
  try { new MutationObserver(function () { var t = document.documentElement.getAttribute('data-theme'); if (!LOCK && (t === 'dark' || t === 'light')) { try { sessionStorage.setItem('gg-theme', t); } catch (e) {} } }).observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] }); } catch (e) {}

  // Viewport branches: matchMedia 'change' alone can miss the first real size of an embedded/late-sized frame,
  // so evaluate now, on change, on (debounced) resize, and on load/pageshow/visibility. Returns an unsubscribe.
  GG.watchMedia = function (fn) {
    var t = null;
    function run() { try { fn(); } catch (e) {} }
    function later() { clearTimeout(t); t = setTimeout(run, 90); }
    window.addEventListener('resize', later);
    ['load', 'pageshow', 'visibilitychange', 'focus'].forEach(function (ev) { window.addEventListener(ev, later); });
    run(); setTimeout(run, 60); setTimeout(run, 400);
    return function () { clearTimeout(t); window.removeEventListener('resize', later); ['load', 'pageshow', 'visibilitychange', 'focus'].forEach(function (ev) { window.removeEventListener(ev, later); }); };
  };

  // Cart — prototype only. Items: [{id, name, price, qty}]
  function readCart() { try { return JSON.parse(localStorage.getItem('gg-cart-proto') || '[]'); } catch (e) { return []; } }
  function writeCart(items) {
    try { localStorage.setItem('gg-cart-proto', JSON.stringify(items)); } catch (e) {}
    window.dispatchEvent(new CustomEvent('gg:cart', { detail: items }));
  }
  GG.cart = function () { return readCart(); };
  GG.cartCount = function () { return readCart().reduce(function (n, i) { return n + (i.qty || 1); }, 0); };
  GG.cartAdd = function (item) {
    var items = readCart();
    var f = items.find(function (i) { return i.id === item.id; });
    if (f) f.qty = (f.qty || 1) + (item.qty || 1); else items.push(Object.assign({ qty: 1 }, item));
    writeCart(items);
  };
  GG.cartRemove = function (id) { writeCart(readCart().filter(function (i) { return i.id !== id; })); };
  GG.cartClear = function () { writeCart([]); };
  GG.cartQty = function (id, delta) { var items = readCart(); var f = items.find(function (i) { return i.id === id; }); if (!f) return; f.qty = Math.max(0, (f.qty || 1) + delta); writeCart(items.filter(function (i) { return i.qty > 0; })); };
  // Bundle & Save: 2-3 units = 5% off, 4+ units = 10% off. A single unit is full price. Free U.S. shipping over $125. Mirrors theme settings bundle_tier_1/2 + free_shipping_threshold.
  GG.FREE_SHIP = 125;
  GG.bundle = function (items) {
    var parse = function (p) { var n = parseFloat(String(p).replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : n; };
    var units = 0, sub = 0;
    (items || readCart()).forEach(function (i) { var q = i.qty || 1; units += q; sub += parse(i.price) * q; });
    var pct = units >= 4 ? 10 : units >= 2 ? 5 : 0;
    var save = sub * pct / 100, total = sub - save, toShip = Math.max(0, GG.FREE_SHIP - total);
    return { units: units, subtotal: sub, pct: pct, save: save, total: total, toShip: toShip, shipPct: Math.min(100, Math.round(total / GG.FREE_SHIP * 100)),
      next: units < 2 ? ('Add ' + (2 - units) + ' or more items to unlock 5% off your whole bundle.') : units < 4 ? ('Add ' + (4 - units) + ' more ' + (4 - units === 1 ? 'item' : 'items') + ' to unlock 10% off your whole bundle.') : '10% off unlocked on your whole bundle.' };
  };

  // Fonts are font-display: block (no fallback flash); the page paints immediately — no body gate.
  // Reveal: anything already in the viewport is never hidden. Only below-the-fold items get .pre and reveal on entry
  // (IntersectionObserver). A throttled sweep + a 4 s safety net guarantee nothing stays hidden; nothing runs on idle.
  var io = null, glSeq = 0;
  function pendingSel() { return '.gg-reveal.pre, .gg-glitch-in[data-gg-obs]:not(.gl-done)'; }
  function fire(el) {
    el.classList.remove('pre'); el.classList.add('in');
    if (el.classList.contains('gg-glitch-in') && !el.classList.contains('gl-done')) {
      el.classList.add('gl-done');
      el.style.setProperty('--gl-delay', Math.min(glSeq++ * 80, 320) + 'ms');
      el.classList.add('gl-fire');
      setTimeout(function () { el.classList.remove('gl-fire'); el.style.removeProperty('--gl-delay'); glSeq = Math.max(0, glSeq - 1); }, 1200);
    }
    if (io) io.unobserve(el);
  }
  var sweepAt = 0;
  function sweep(force) {
    var pend = document.querySelectorAll(pendingSel()); if (!pend.length) return;
    var vh = window.innerHeight || 0;
    pend.forEach(function (el) {
      if (force || vh === 0) { fire(el); return; }
      var r = el.getBoundingClientRect();
      if (r.top < vh * 1.05 && r.bottom > -20) fire(el);
    });
  }
  function throttledSweep() { var now = Date.now(); if (now - sweepAt < 350) return; sweepAt = now; sweep(false); }
  window.addEventListener('scroll', throttledSweep, { passive: true });
  window.addEventListener('resize', throttledSweep);
  ['load', 'pageshow', 'visibilitychange', 'focus'].forEach(function (ev) { window.addEventListener(ev, function () { sweepAt = 0; throttledSweep(); }); });
  GG.glitch = function (el) { if (!el) return; el.classList.remove('gl-fire'); void el.offsetWidth; el.classList.add('gl-fire'); setTimeout(function () { el.classList.remove('gl-fire'); }, 700); };
  GG.observeReveals = function (root) {
    root = root || document;
    var els = root.querySelectorAll('.gg-reveal:not([data-gg-obs]), .gg-glitch-in:not([data-gg-obs])');
    if (!els.length) return;
    var vh = window.innerHeight || 0, reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!io && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) fire(en.target); }); }, { rootMargin: '0px 0px -4% 0px', threshold: 0.02 });
    }
    els.forEach(function (el) {
      el.setAttribute('data-gg-obs', '1');
      if (reduce || !io || vh === 0) { fire(el); return; }
      var r = el.getBoundingClientRect();
      if (r.top <= vh * 1.05 || r.width === 0 || r.height === 0) { fire(el); return; }   // in view / above / unsized: visible now
      if (el.classList.contains('gg-reveal')) el.classList.add('pre');
      io.observe(el);
    });
    setTimeout(function () { var vh2 = window.innerHeight || 0; els.forEach(function (el) { if (el.classList.contains('pre') || (el.classList.contains('gg-glitch-in') && !el.classList.contains('gl-done'))) { var r = el.getBoundingClientRect(); if (vh2 === 0 || r.top < vh2 * 1.5) fire(el); } }); }, 4000);
  };
  // Tag inline-styled panels so the dark theme can frost them (see gg-rebrand.css .gg-panel)
  GG.tagPanels = function (root) {
    (root || document).querySelectorAll('[style*="--gg-card-bg"], [style*="--gg-surface"]').forEach(function (el) { el.classList.add('gg-panel'); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { GG.tagPanels(); }); else GG.tagPanels();
  setInterval(function () { GG.tagPanels(); }, 1200);
})();
